import { Grid } from "@mui/material";
import NameInput from "./NameInput";
import DocumentNumberInput from "./DocumentNumberInput";
import HealthInsuranceSelect from "./HealthInsuranceSelect";
import HealthInsurancePlanInput from "./HealthInsurancePlanInput";
import InsuranceNumberInput from "./InsuranceNumberInput";
import EmailInput from "./EmailInput";
import PhoneInput from "./PhoneInput";
import { useForm } from "react-hook-form";
import _ from "lodash";
import GenderInput from "./GenderInput";
import BirthDateInput from "./BirthDateInput";

const defaultValues = {
  id: "",
  healthInsurance: "",
  isCustomHealthInsurance: false,
  healthInsurancePlan: "",
  insuranceNumber: "",
  name: "",
  surname: "",
  documentNumber: "",
  email: "",
  phone: "",
  gender: "",
  birthDate: "",
};

const PatientForm = ({ SurnameInput, children, onSubmit, contactRequired, phoneRequired = contactRequired, initialValues: initialValuesProp, showShareInfo = true, allowCustom = true }) => {
  const formDefaultValues = initialValuesProp ? _.mapValues(initialValuesProp, (value) => value || "") : defaultValues;
  const form = useForm({
    defaultValues: formDefaultValues,
    shouldUnregister: false
  });

  const { handleSubmit } = form;

  const onSubmitWithDefaults = (patient) => {
    const defaultedPatient = _.mapValues(patient, (value) => (_.isNil(value) || value === "") ? null : value);
    onSubmit(defaultedPatient);
  };

  return (
    <form onSubmit={handleSubmit(onSubmitWithDefaults)} autoComplete="off">
      <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0 }}>
        <Grid item xs={12} md={6}>
          <SurnameInput form={form} />
        </Grid>
        <Grid item xs={12} md={6}>
          <NameInput form={form} />
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0 }}>
        <Grid item xs={12} lg={4}>
          <DocumentNumberInput form={form} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <BirthDateInput form={form} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <GenderInput form={form} />
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0 }}>
        <Grid item xs={12} md={4}>
          <HealthInsuranceSelect form={form} allowCustom={allowCustom} />
        </Grid>
        <Grid item xs={12} md={2}>
          <HealthInsurancePlanInput form={form} />
        </Grid>
        <Grid item xs={12} md={6}>
          <InsuranceNumberInput form={form} />
        </Grid>
      </Grid>
      {showShareInfo && (
      <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0 }}>
        <Grid item xs={12} md={6}>
          <EmailInput form={form} required={contactRequired} />
        </Grid>
        <Grid item xs={12} md={6}>
          <PhoneInput form={form} required={phoneRequired} />
        </Grid>
      </Grid>
      )}
      {children}
    </form>
  );
};

export default PatientForm;
